if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm ? this.mainProductForm.querySelector(".m-add-to-cart") : null;
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.disableSelectedVariantDefault = this.mainProduct.dataset.disableSelectedVariantDefault === "true" || false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        this.variantData = this.getVariantData();

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const isStickyVisible = entry.intersectionRatio !== 1;
                this.container.style.setProperty("--m-translate-y", isStickyVisible ? 0 : "100%");
                document.documentElement.classList[isStickyVisible ? "add" : "remove"]("stick-atc-show");
                this.offsetChatWidget(isStickyVisible);
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();

        this.setObserveTarget();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();
        this.applyChatOffset();
        this.watchChatWidget();

        if (this.container && "ResizeObserver" in window) {
          this.stickyBarResizeObserver = new ResizeObserver(() => {
            this.setStickyAddToCartHeight();
            this.applyChatOffset();
          });
          this.stickyBarResizeObserver.observe(this.container);
        }

        this.domNodes.select.addEventListener("change", (e) => {
          const { target } = e;
          const variantPicker = this.mainProduct.querySelector('variant-picker');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
          this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : this.toggleAddButton(true, window.MinimogStrings.unavailable);

          const selectedOption = target.options[target.selectedIndex];
          const selectedOptionIds = selectedOption.dataset.options.split(',').filter(id => id);

          if (variantPicker) {
            selectedOptionIds.forEach((optionId) => {
              const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
              const { tagName } = input;
              switch (tagName) {
                case "OPTION":
                  const inputParent = input.parentNode; // select tag
                  inputParent.value = input.value;
                  break;
                case "INPUT":
                  input.checked = true;
                  break;
              }
            });
            variantPicker.dispatchEvent(new Event("change"));
          }
        });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector('.m-product-option--dropdown-select');

        pickerFields.value = '';
        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        const barHeight = this.container?.offsetHeight || this.offsetHeight;
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", `${barHeight}px`);
        window.MinimogSettings.stickyAddToCartHeight = barHeight;
        if (document.documentElement.classList.contains("stick-atc-show")) {
          this.offsetChatWidget(true);
        }
      }

      offsetChatWidget(isStickyVisible) {
        this.chatShouldOffset = Boolean(isStickyVisible);
        if (!this.chatShouldOffset) {
          document.documentElement.classList.remove("stick-atc-chat-lift");
        }
        this.applyChatOffset();
        if (this.chatShouldOffset) {
          clearTimeout(this.chatOffsetTimer);
          this.chatOffsetTimer = setTimeout(() => this.applyChatOffset(), 600);
          clearTimeout(this.chatOffsetTimerLate);
          this.chatOffsetTimerLate = setTimeout(() => this.applyChatOffset(), 1800);
        }
      }

      watchChatWidget() {
        if (this.chatWidgetObserver) return;
        this.chatWidgetObserver = new MutationObserver(() => {
          clearTimeout(this.chatWidgetDebounce);
          this.chatWidgetDebounce = setTimeout(() => this.applyChatOffset(), 120);
        });
        this.chatWidgetObserver.observe(document.body, { childList: true, subtree: true });
      }

      applyChatOffset() {
        if (!document.body.classList.contains("template-product")) return;

        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        const iframes = document.querySelectorAll(
          "#dummy-chat-button-iframe, iframe#dummy-chat-button-iframe, iframe[title='Chat button'], iframe[title='Shopify chat']"
        );
        const stickyBar = this.container || document.querySelector(".m-sticky-addtocart");
        const barHeight = stickyBar ? stickyBar.getBoundingClientRect().height : 0;
        const chatZIndex = "50";

        const styleChatHosts = () => {
          document.querySelectorAll("shopify-chat, #ShopifyChat").forEach((el) => {
            el.style.setProperty("z-index", chatZIndex, "important");
            el.style.setProperty("position", "relative", "important");
          });
        };

        if (!isMobile) {
          const bottomOffset = this.chatShouldOffset
            ? `${Math.max(barHeight, 76) + 20}px`
            : "16px";
          styleChatHosts();
          iframes.forEach((el) => {
            el.style.setProperty("bottom", bottomOffset, "important");
            el.style.setProperty("top", "auto", "important");
            el.style.setProperty("right", "16px", "important");
            el.style.setProperty("left", "auto", "important");
            el.style.setProperty("z-index", chatZIndex, "important");
            el.style.removeProperty("margin-bottom");
          });
          return;
        }

        const shouldLift = Boolean(this.chatShouldOffset && barHeight > 0);
        const measuredHeight = Math.max(
          barHeight,
          parseInt(MinimogSettings.stickyAddToCartHeight, 10) || 0,
          72
        );
        if (shouldLift) {
          document.documentElement.style.setProperty("--f-sticky-atc-bar-height", `${measuredHeight}px`);
          document.documentElement.classList.add("stick-atc-chat-lift");
        } else {
          document.documentElement.classList.remove("stick-atc-chat-lift");
        }

        const bottomPx = shouldLift ? measuredHeight + 24 : 16;
        const bottomOffset = `calc(${bottomPx}px + env(safe-area-inset-bottom, 0px))`;
        document.documentElement.style.setProperty("--product-chat-offset-bottom", bottomOffset);

        styleChatHosts();
        document.querySelectorAll("shopify-chat, #ShopifyChat").forEach((el) => {
          if (shouldLift) {
            el.style.setProperty("--shopify-chat-button-bottom", bottomOffset);
          } else {
            el.style.removeProperty("--shopify-chat-button-bottom");
          }
        });

        iframes.forEach((el) => {
          el.style.setProperty("bottom", bottomOffset, "important");
          el.style.setProperty("top", "auto", "important");
          el.style.setProperty("left", "12px", "important");
          el.style.setProperty("right", "auto", "important");
          el.style.setProperty("z-index", chatZIndex, "important");
          el.style.removeProperty("margin-bottom");
        });
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;
          this.currentVariant = e.data.variant;
          if (this.currentVariant) {
            variantInput.value = e.data.variant.id;
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut)
          } else {
            variantInput.value = '';
            this.toggleAddButton(true, window.MinimogStrings.unavailable)
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        let customFieldFirst = customFields[0];
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout.click());
              }
            },
            true
          );
        }
        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        }
      }
    }
  );
}
